import { Routine } from 'redux-saga-routines';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { EmailType } from '../../common/enums/EmailType';
import { errorToast, successToast } from '../../common/helpers/toastrHelper';
import { sendReminder } from '../../services/candidateService';
import { getEmailTemplate } from '../../services/emailTemplateService';
import { candidateSendReminderRoutine, fetchReminderTemplateRoutine } from './routines';

function* fetchReminderTempate() {
  try {
    const response = yield call(getEmailTemplate, EmailType.CandidateRefRequestReminder);
    yield put(fetchReminderTemplateRoutine.success(response));
  } catch (error) {
    yield put(fetchReminderTemplateRoutine.failure(error.message));
  }
}

function* watchFetchReminderTempate() {
  yield takeEvery(fetchReminderTemplateRoutine.TRIGGER, fetchReminderTempate);
}

function* sendReminderRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(sendReminder, payload);

    yield put(candidateSendReminderRoutine.success(response));
    yield call(successToast, 'Success! Reminder sent to candidate(s)', 'toast.reminderSuccess');
  } catch (error) {
    yield put(candidateSendReminderRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchSendReminderRequest() {
  yield takeEvery(candidateSendReminderRoutine.TRIGGER, sendReminderRequest);
}

export default function* sendReminderSaga() {
  yield all([
    watchFetchReminderTempate(),
    watchSendReminderRequest()
  ]);
}
